import React from "react";
import { Button } from "react-bootstrap";
import Thumbnail from "./Thumbnail";
import action_icon_1 from "../../../../Assets/svg/tableData/action-icon-1.svg";
import action_icon_2 from "../../../../Assets/svg/tableData/action-icon-2.svg";
import { useSelector } from "react-redux";
import useCheckPermission from "../../../../hooks/useCheckPermission";

const TutorialRow = ({
  tutorial,
  handleEditTutorial,
  confirmDelete,
  setVideoUrl,
  setShowVideoModal,
}) => {

  const handleThumbnailClick = (media, mediaType) => {
    if (mediaType === "video") {
      setVideoUrl(media);
      setShowVideoModal(true);
    } else if (mediaType === "pdf") {
      window.open(media, "_blank");
    }
  };

  return (
    <tr>
      <td>
        <Thumbnail tutorial={tutorial} onClick={handleThumbnailClick} />
      </td>
      <td>
        <b>{tutorial?.title || "-"}</b>
      </td>
      <td>{tutorial?.description || "-"}</td>
      <td>{tutorial?.paid ? "Paid" : "Free"}</td>
      <td>{tutorial?.media_type || "-"}</td>
      <td>
        {tutorial?.created_at
          ? new Date(tutorial?.created_at).toLocaleDateString()
          : "-"}
      </td>
      <td className="text-capitalize">{tutorial?.status || "-"}</td>
      <td>
        <div className="d-flex align-items-center gap-10">
          {useCheckPermission("manageTutorial", "UPDATE") && <Button
            className="border-0 p-0"
            variant="transparent"
            onClick={() => handleEditTutorial(tutorial)}
          >
            <img src={action_icon_1} alt="" />
          </Button>}
          {useCheckPermission("manageTutorial", "DELETE") && <Button
            className="border-0 p-0"
            variant="transparent"
            onClick={() => confirmDelete(tutorial?._id)}
          >
            <img src={action_icon_2} alt="" />
          </Button>}
        </div>
      </td>
    </tr>
  );
};

export default TutorialRow;
